<template>
    <footer class="footer">
        <div class="mt-0">
            <img alt="Familjekortet logga" class="logo" src="/assets/frontend/logo.png" />
            <div>
                <a href="https://www.facebook.com/familjekortet.se" target="_blank"> <icon name="facebook-small" class="m-3"><a href="_blank"></a></icon></a>
                <a href="https://www.instagram.com/familjekortet.se" target="_blank"> <icon name="instagram-small" class="m-3"><a href="_blank"></a></icon></a>
            </div>

            <div class="menu categories">
                <ul class="list-item list-unstyled">
                    <li class="averta-black flex">
                        <span>Kategorier</span>
                        <icon class="float-right ml-auto" name="plus" data-toggle="collapse" href="#categoriesFooter" v-if="$isMobile"></icon>
                    </li>
                    <div class="collapse" id="categoriesFooter"  v-bind:class="{ show: !$isMobile }">
                        <li v-for="category in categories.filter(c => c.parent_id === null)" :key="category.id" class="text-capitalize">
                            <inertia-link :href="`/${category.slug}`" class="d-block">{{category.name}}</inertia-link>
                        </li>
                    </div>
                </ul>
            </div>
            <div class="menu babycard">
                <ul class="list-item list-unstyled">
                    <li class="averta-black" v-if="!$isMobile">Övrigt</li>
                    <li><inertia-link href="/vara-partners">{{ $t('our_partners') }}</inertia-link></li>
                    <li><span style="cursor:pointer;" @click="checkIfClient"> {{ $t('for_companies') }}</span></li>
                     <li><inertia-link href="/alla-foretag">Alla företag</inertia-link></li>
                    <li><inertia-link href="/vanliga-fragor"> {{ $t('faq') }} </inertia-link></li>
                    <li><inertia-link href="/om-oss"> {{ $t('about_familjekortet') }} </inertia-link></li>
                    <li><inertia-link href="/kontakta-oss"> Kontakta oss </inertia-link></li>
                </ul>
            </div>
            <div v-if="!$store.getters.isNativeApp" class="login-partner">
                <span v-if="!currentUser" @click="loginAsPartner">
                    <icon name="login"></icon>
                     Logga in företag
                </span>

                <span v-if="isClient" @click="loginAsPartner">
                    <icon name="user"></icon>
                     Mina sidor Företag
                </span>
            </div>
        </div>
        <div class="copyright">
            <span @click="scrollToTop">
                <icon class="back-to-top" name="back-to-top"></icon>
            </span>
            <span class="info first">{{ new Date().getFullYear()  }} © Familjekortet Sverige AB</span>
            <br v-if="$isMobile">
            <span v-if="!$isMobile"> &bull; </span>
            <span class="info first">Org-nr: 556997-1236</span>
            <br v-if="$isMobile">
            <span v-if="!$isMobile"> &bull; </span>
            <span class="info">Mariedalsgatan 7, 503 38 Borås</span>
            <br v-if="$isMobile">
            <span v-if="!$isMobile"> &bull; </span>
            <span class="info">033-430 80 90</span>
            <br v-if="$isMobile">
            <span v-if="!$isMobile"> &bull; </span>
            <span class="info">
                <inertia-link href="/kontakta-oss">Kontakta oss</inertia-link>
            </span><br>
            <span class="info cookies"> <inertia-link href="/membership-terms"> {{ $t('membership-terms') }}</inertia-link><span> |</span></span>
            <span class="info cookies"> <inertia-link href="/integrity-policy"> {{ $t('integrity-policy') }}</inertia-link><span> |</span></span>
            <span class="info cookies"> <inertia-link href="/cookies"> {{ $t('cookies') }}</inertia-link></span>
        </div>
    </footer>
</template>

<script>
    export default {
        inject: ['$isMobile'],
        computed: {
            currentUser() {
                return this.$store.state.user;
            },
            isClient() {
                return this.$store.getters.isClient;
            },
            categories() { return this.$page.props.categories; },
        },
        methods: {
            loginAsPartner(){
                if (this.isClient) {
                    this.$router.push({ name: 'client' });
                } else {
                    $("#clientLoginModal").modal("toggle");
                }
            },
            checkIfClient() {
                if (this.isClient) {
                    this.$router.push({ name: "partner" });
                } else {
                    $("#clientLoginModal").modal("toggle");
                }
            },
            scrollToTop() {
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        }
    };
</script>
